export const SOCIAL_MEDIA_ICONS_WHITE = {
  phone:
    "https://storage.googleapis.com/prod_gsignature_user_images/generator.gs.com/media/images/2025-02-21T14:22:42.192Z_b3c60f63-8155-4210-9596-7172c148b30c",
  email:
    "https://storage.googleapis.com/prod_gsignature_user_images/generator.gs.com/media/images/2025-02-21T14:23:14.967Z_a6e11bf2-ca36-443b-a2d8-7f29bc138ad4",
  www: "https://storage.googleapis.com/prod_gsignature_user_images/generator.gs.com/media/images/2024-09-27T06:44:15.951Z_7d6dc70f-284c-410c-9d93-a9ee4f8a40df",
  facebook:
    "https://storage.googleapis.com/prod_gsignature_user_images/generator.gs.com/media/images/2024-08-26T13:36:07.326Z_733c7249-76cf-47cd-81d3-dc01fd7c16e2",
  linkedin:
    "https://storage.googleapis.com/prod_gsignature_user_images/generator.gs.com/media/images/2024-08-26T13:37:51.133Z_d9298197-8198-4847-919b-24e5c169aa98",
  twitter:
    "https://storage.googleapis.com/prod_gsignature_user_images/generator.gs.com/media/images/2024-09-23T16:21:38.919Z_54227580-dd6d-4678-a700-2786ad5d85cc",
  instagram:
    "https://storage.googleapis.com/prod_gsignature_user_images/generator.gs.com/media/images/2024-08-26T13:37:34.722Z_44df56f6-3301-4c62-bcd6-df220d761715",
  behance:
    "https://storage.googleapis.com/prod_gsignature_user_images/generator.gs.com/media/images/2024-08-26T13:35:04.528Z_89f82a62-b75f-4a10-bf64-1dd104e7971f",
  coffee:
    "https://storage.googleapis.com/prod_gsignature_user_images/generator.gs.com/media/images/2024-08-26T13:35:21.783Z_f43f83f2-e276-489d-8303-8a8d0cc50952",
  diaspora:
    "https://storage.googleapis.com/prod_gsignature_user_images/generator.gs.com/media/images/2024-08-26T13:35:36.238Z_bd6531f3-b3bd-4f58-810d-4e471cd96825",
  github:
    "https://storage.googleapis.com/prod_gsignature_user_images/generator.gs.com/media/images/2024-08-26T13:36:19.479Z_4bb18b73-1e2e-42b4-bf41-deca918720b2",
  gitlab:
    "https://storage.googleapis.com/prod_gsignature_user_images/generator.gs.com/media/images/2024-08-26T13:36:43.815Z_7f8619a8-dc0a-48e2-9f21-45485b0b9208",
  gitter:
    "https://storage.googleapis.com/prod_gsignature_user_images/generator.gs.com/media/images/2024-08-26T13:36:58.102Z_a50622d2-1935-4b1e-9f93-b602d6c43e97",
  heart:
    "https://storage.googleapis.com/prod_gsignature_user_images/generator.gs.com/media/images/2024-08-26T13:37:12.618Z_2b59cbe8-8282-4dd8-b093-8bbd02e8b5dc",
  mastodon:
    "https://storage.googleapis.com/prod_gsignature_user_images/generator.gs.com/media/images/2024-08-26T13:38:19.128Z_3194a01d-1934-40a9-8358-a14fea059373",
  menu: "https://storage.googleapis.com/prod_gsignature_user_images/generator.gs.com/media/images/2024-08-26T13:38:34.502Z_cdb2cc08-8b5d-4091-894d-3c3110d74182",
  ok: "https://storage.googleapis.com/prod_gsignature_user_images/generator.gs.com/media/images/2024-08-26T13:38:47.805Z_3ac145d3-eea4-4d63-ace4-d227bea6b652",
  reddit:
    "https://storage.googleapis.com/prod_gsignature_user_images/generator.gs.com/media/images/2024-08-26T13:39:02.420Z_2e146e92-4698-4c5c-a22b-e9fb8c24d9f7",
  skype:
    "https://storage.googleapis.com/prod_gsignature_user_images/generator.gs.com/media/images/2024-08-26T13:39:18.012Z_3e4ff1d6-5816-4731-a078-b35734845dd6",
  slack:
    "https://storage.googleapis.com/prod_gsignature_user_images/generator.gs.com/media/images/2024-08-26T13:39:34.053Z_50381480-4ffe-4856-bcab-f7fc4ed1f558",
  stackoverflow:
    "https://storage.googleapis.com/prod_gsignature_user_images/generator.gs.com/media/images/2024-08-26T13:39:54.077Z_9ac562de-4043-4285-940b-9c1b987c3184",
  telegram:
    "https://storage.googleapis.com/prod_gsignature_user_images/generator.gs.com/media/images/2024-08-26T13:40:13.045Z_e66c97a0-c527-48c5-9906-c794e54a880b",
  vk: "https://storage.googleapis.com/prod_gsignature_user_images/generator.gs.com/media/images/2024-08-26T13:41:07.102Z_47c8dd04-8004-4e4c-b2a9-0f0fc360f6b0",
  whatsapp:
    "https://storage.googleapis.com/prod_gsignature_user_images/generator.gs.com/media/images/2024-08-26T13:41:22.167Z_057d568f-0879-4e49-994d-48295440e8fa",
  xing: "https://storage.googleapis.com/prod_gsignature_user_images/generator.gs.com/media/images/2024-08-26T13:41:37.633Z_944dc88c-4d5e-4b63-a700-8ff42192d4db",
  youtube:
    "https://storage.googleapis.com/prod_gsignature_user_images/generator.gs.com/media/images/2024-08-26T13:41:51.250Z_68f28ef9-abab-4ce7-b2c4-b6d4c6e02b84",
};

export const SOCIAL_MEDIA_PLATFORMS = {
  DEFAULT: ["facebook", "linkedin", "twitter", "instagram"],
  ADDITIONAL: [
    "behance",
    "coffee",
    "diaspora",
    "github",
    "gitlab",
    "gitter",
    "heart",
    "mastodon",
    "menu",
    "ok",
    "reddit",
    "skype",
    "slack",
    "stackoverflow",
    "telegram",
    "vk",
    "whatsapp",
    "xing",
    "youtube",
  ],
};

export const SOCIAL_MEDIA_NAMES = {
  phone: "Phone",
  email: "Email",
  www: "Website",
  facebook: "Facebook",
  linkedin: "LinkedIn",
  twitter: "X / Twitter",
  instagram: "Instagram",
  behance: "Behance",
  coffee: "Buy Me a Coffee",
  diaspora: "Diaspora",
  github: "GitHub",
  gitlab: "GitLab",
  gitter: "Gitter",
  heart: "Heart",
  mastodon: "Mastodon",
  menu: "Menu",
  ok: "Odnoklassniki",
  reddit: "Reddit",
  skype: "Skype",
  slack: "Slack",
  stackoverflow: "Stack Overflow",
  telegram: "Telegram",
  vk: "VKontakte",
  whatsapp: "WhatsApp",
  xing: "Xing",
  youtube: "YouTube",
};

export function generateSocialMediaIconHtml(
  platform: string,
  backgroundColor: string,
  size: "small" | "large" = "small",
): string {
  const iconUrl =
    SOCIAL_MEDIA_ICONS_WHITE[platform as keyof typeof SOCIAL_MEDIA_ICONS_WHITE];
  if (!iconUrl) {
    return "";
  }

  const totalSize = size === "large" ? 40 : 28;
  const padding = size === "large" ? 10 : 7;
  const iconSize = totalSize - padding * 2;
  const borderRadius = "50%";

  return `<div style="display: block; width: ${totalSize}px; height: ${totalSize}px; padding: ${padding}px; background-color: ${backgroundColor}; border-radius: ${borderRadius}; box-sizing: border-box;">
              <img src="${iconUrl}" alt="${platform}" width="${iconSize}" height="${iconSize}" style="display: block; width: ${iconSize}px; height: ${iconSize}px;">
          </div>`;
}
